module.exports = "/_next/static/images/ashwin-ad00f07592f17b11576b0652065fa92c.png";